import { z } from 'zod';
import { PORTADA_POSICIONES } from './orden-notas.js';
/**
 * La **maqueta** de la portada: cómo se dibuja el bloque que abre la página principal.
 *
 * Es un atributo del bloque Portada, **no del sitio**: la redacción la elige por edición, igual que
 * elige qué notas van. Cambiarla no es desplegar código.
 *
 *  - **A** — la vigente: la principal a dos columnas, la 2 y la 3 apiladas al costado y la 4-6
 *    cerrando en una fila de tres.
 *  - **B** — nota única: una sola nota toma todo el frente del diario y debajo no hay más portada.
 *  - **C** — dos pares + 3: dos notas del mismo peso comparten el frente en mitades iguales, y
 *    debajo van las mismas tres chicas que cierran A.
 */
export const MaquetaPortadaSchema = z.enum(['A', 'B', 'C']);
/** La que traen los medios que nunca la tocaron: la portada de siempre. */
export const MAQUETA_PORTADA_DEFECTO = 'A';
/**
 * Cuántas posiciones **dibuja** cada maqueta.
 *
 * Guardarse se guardan siempre `PORTADA_POSICIONES` (ver `orden-notas.ts`): la maqueta decide qué se
 * ve, no qué hay curado. Es lo que permite pasar de A a B y volver sin perder la portada de seis que
 * alguien ya había armado.
 */
export const POSICIONES_POR_MAQUETA = {
    A: PORTADA_POSICIONES,
    B: 1,
    C: 5,
};
/** Cuántas posiciones dibuja esa maqueta. La 1 es siempre la principal. */
export function posicionesDeMaqueta(maqueta) {
    return POSICIONES_POR_MAQUETA[maqueta];
}
/** Las posiciones grandes de C, las que van al frente y comparten alto. */
export const PORTADA_C_POSICIONES_GRANDES = 2;
